import get from 'lodash/get';
import startCase from 'lodash/startCase';
import { convertText } from './methods/helpers';

export const errorMessages = {
  401: 'Session has expired. Please login again.',
  403: 'Action not allowed. Please contact support@securityrisk.com',
  404: 'Item could not be found. Please try alternate item.',
  500: 'Internal server error. Please contact support@securityrisk.com',
  502: 'Server is temporarily unavailable. Please try again later. Contact support@softwarerisk.com if problem persists.',
  503: 'Service is unavailable. Please try again later. Contact support@softwarerisk.com if problem persists.',
  504: 'Server is temporarily unavailable. Please try again later. Contact support@softwarerisk.com if problem persists.',
  999: 'Some error has occurred. Please try again later. Contact support@softwarerisk.com if problem persists.',
};

export const errorHandler = err => {
  const errorStatus = get(err, 'response.status', 999);
  // To Force logout on 401
  if (errorStatus === 401) {
    setTimeout(() => {
      window.sessionStorage.clear();
      window.location.href = 'login';
    }, 500);
  }

  if (errorStatus === 422) {
    const errorMessageData = get(err, 'response.data.data', []);
    let errorMessage;
    if (Object.entries(errorMessageData).length > 0) {
      const [target] = Object.entries(errorMessageData);
      errorMessage = `${convertText(startCase(target[0]))} - ${convertText(
        target[1],
      )}`;
    } else {
      errorMessage = get(err, 'response.data.detail', 'Invalid input');
    }

    return errorMessage;
  }

  return get(errorMessages, `${errorStatus}`);
};

export const loginErrorHandler = err => {
  const errorStatus = get(err, 'response.status', 999);
  if (errorStatus === 401) {
    return 'Invalid email or password';
  } else if (errorStatus === 426) {
    window.location.reload(true);
    return get(errorMessages, `${errorStatus}`);
  } else {
    return get(errorMessages, `${errorStatus}`);
  }
};
